import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { motion as m } from 'framer-motion'
import store from '../store/store'
import Cards from '../components/Cards'
import Results from '../components/Results'
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded'
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded'

export default function LikedRecipes() {

  const recipes = store((state) => state.recipes)
  const isMenuOpen = store((state) => state.isMenuOpen)
  const setIsMenuOpen = store((state) => state.setIsMenuOpen)
  const isUserLogged = store((state) => state.isUserLogged)
  const user = store((state) => state.user)
  const setFavorite = store((state) => state.setFavorite)

  const navigate = useNavigate()

  let likedRecipes = []
  if (isUserLogged) {
    likedRecipes = recipes.filter(recipe => user.favorite.includes(recipe.id))
  }

  const handleNavigate = (id) => {
    navigate(`/recipe/${id}`)
  }

  const handleFavorite = (id) => {
    setFavorite(id)
  }

  // auto close the menu once the page is loaded
  useEffect(() => {
    setIsMenuOpen(false)
},[])

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // fallback where the user is only a guest
  useEffect(()=> {
    if (!isUserLogged) {
      console.log("not auhorized")
      navigate('/signin')
    }
  },[isUserLogged])

  const animDuration = 0.4
  
  const spring = {
    type: "spring",
    damping: 20,
    stiffness: 600,
  };

  const containerVar = {
    initial: {
      x:'-100%',
      transition: {
        duration: animDuration,
      },
    },
    animate: {
      x: '0%',
      transition: {
        duration: animDuration,
      },
    },
    exit: {
        x: '-100%',
        transition: {
            duration: animDuration,
          },
    },
  }

  if (isUserLogged) {
    return (
      <main>
        <m.div
          id='home_container'
          variants={containerVar}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <Results />
          <div id="cards_container">
            {likedRecipes.map((recipe) => (
              <div key={recipe.title + '_' + recipe.id} style={{ position: 'relative' }}>
                { 
                  recipe.favorite?
                  <FavoriteRoundedIcon id='heart_icon' onClick={() => handleFavorite(recipe.id)}/> 
                : 
                  <FavoriteBorderRoundedIcon id='heart_icon' onClick={() => handleFavorite(recipe.id)}/>
                }
                <div key={recipe.id} id="card_container" onClick={() => handleNavigate(recipe.id)}>
                  <div id='card_img_container'>
                    <img src={recipe.image} alt={recipe.title} />
                    <div id='card_overlay'></div>
                  </div>
                  <div id="card_infos">
                    <h3>{recipe.title}</h3>
                    <p>{recipe.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </m.div>
      </main>
    )
  }
}
